import { render } from "./homeView.vue?vue&type=template&id=88a6509c&scoped=true"
import script from "./homeView.vue?vue&type=script&lang=js"
export * from "./homeView.vue?vue&type=script&lang=js"

import "./homeView.vue?vue&type=style&index=0&id=88a6509c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88a6509c"]])

export default __exports__